// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F1c99v{display:flex;flex-flow:row wrap;list-style:none;margin:0;padding:0;min-width:680px;box-sizing:border-box}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `F1c99v`
};
export default ___CSS_LOADER_EXPORT___;
